import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./SideProducts.css";
import useWidth from "../../hooks/useWidth";
import useVariantSelection from "../../hooks/useVariantSelection";
import useVariantSelectedSku from "../../hooks/useVariantSelectedSku";
import { actionToBringInSkuPrice } from "../../actions/productActions";
import {
  removeDuplicatesFromArray,
  setScrollHeight,
} from "../../libraries/ercLibrary";
import { actionToAddSkuItemInCart } from "../../actions/cartActions";
import SideProductModalContent from "./SideProductModalContent";

export default function SideProducts(props) {
  const dispatch = useDispatch();
  const width = useWidth();
  const [qty] = useState("1");
  const alertRef = useRef("");
  const addedInCartRef = useRef("");
  const history = useHistory();

  // PROPS COMING FROM "PurchaseComponent"
  const {
    loadingProduct,
    errorProduct,
    product,
    skuData,
    setNoSkuAlert,
    isThereApendingOrder,
    createdFingerPrint,
    loadingSideProducts,
    errorSideProducts,
    sideProducts,
  } = props;

  // BRING IN CART SKU ITEMS
  const addOrRemoveSkuItemInCart = useSelector(
    (state) => state.addOrRemoveSkuItemInCart
  );
  const { cartSkuItems } = addOrRemoveSkuItemInCart;

  // ARRAY THAT HOLDS CHOOSEN VARIANTS
  const [choosenVariants, setChoosenVariants] = useState("");
  //REACT STATES THAT MENAGES ALERT IF QTY OR VARIANTS ARE NOT CHOOSEN BEFORE HITTING ADD TO CART BUTTON
  const [variantAlert, setVariantAlert] = useState({ index: -1, message: "" });

  // Returns single sku if any and fullVariantsArray
  const variants = useVariantSelection(
    loadingProduct,
    errorProduct,
    product,
    choosenVariants
  );

  // returns choosen sku
  useVariantSelectedSku(
    variants.fullVariantsArray,
    choosenVariants,
    product,
    actionToBringInSkuPrice
  );

  //REDUX STATE THAT HOLDS PRODUCT SKU DETAILS
  const bringInSkuPrice = useSelector((state) => state.bringInSkuPrice);
  const { loading: loadingSku, skuData: sideSkuData } = bringInSkuPrice;

  // DETECT IF ITEM IS ADDED IN CART AND READY TO ADD A NEW ITEM
  const [readyToAddNew, setReadyToAddNew] = useState(true);
  useEffect(() => {
    if (!readyToAddNew) {
      setTimeout(() => {
        setReadyToAddNew(true);
      }, 1000);
    }
  }, [readyToAddNew]);

  // DETECT THE COLOR AND DECIDE THE SIDE PRODUCTS VARIANT
  const [choosenSetOfSideProducts, setChoosenSetOfSideProducts] = useState([]);
  useEffect(() => {
    if (
      !loadingSideProducts &&
      !errorSideProducts &&
      sideProducts &&
      sideProducts.length > 0 &&
      product
    ) {
      setChoosenSetOfSideProducts(
        sideProducts.map((sideProduct) => {
          return (
            (skuData &&
              skuData.skus[0].size !== "Pass" &&
              sideProduct.skus.find(
                (sku) =>
                  sku.color === skuData.skus[0].color &&
                  (sku.size.includes("(")
                    ? sku.size?.split("-")[1].split("(")[0] ===
                        skuData.skus[0].size?.split("-")[1].split("(")[0] &&
                      sku.countInStock > 0
                    : sku.size?.split("-")[1] ===
                        skuData.skus[0].size?.split("-")[1] &&
                      sku.countInStock > 0)
              )) ||
            (skuData &&
              skuData.skus[0].size !== "Pass" &&
              sideProduct.skus.find(
                (sku) =>
                  sku.color === skuData.skus[0].color && sku.countInStock > 0
              )) ||
            (skuData &&
              skuData.skus[0].size !== "Pass" &&
              sideProduct.skus.find((sku) =>
                sku.size.includes("(")
                  ? sku.size?.split("-")[1].split("(")[0] ===
                      skuData.skus[0].size?.split("-")[1].split("(")[0] &&
                    sku.countInStock > 0
                  : sku.size?.split("-")[1] ===
                      skuData.skus[0].size?.split("-")[1] &&
                    sku.countInStock > 0
              )) ||
            (sideSkuData &&
              skuData.skus[0].size !== "Pass" &&
              sideProduct.skus.find(
                (sku) =>
                  sku.color === skuData.skus[0].color &&
                  (sku.size.includes("(")
                    ? sku.size?.split("-")[1].split("(")[0] ===
                        skuData.skus[0].size?.split("-")[1].split("(")[0] &&
                      sku.countInStock > 0
                    : sku.size?.split("-")[1] ===
                        skuData.skus[0].size?.split("-")[1] &&
                      sku.countInStock > 0)
              )) ||
            (sideSkuData &&
              sideProduct.skus.find(
                (sku) =>
                  sku.color === skuData.skus[0].color && sku.countInStock > 0
              )) ||
            (sideSkuData &&
              skuData.skus[0].size !== "Pass" &&
              sideProduct.skus.find((sku) =>
                sku.size.includes("(")
                  ? sku.size?.split("-")[1].split("(")[0] ===
                      skuData.skus[0].size?.split("-")[1].split("(")[0] &&
                    sku.countInStock > 0
                  : sku.size?.split("-")[1] ===
                      skuData.skus[0].size?.split("-")[1] &&
                    sku.countInStock > 0
              )) ||
            (product &&
              sideProduct.skus.find(
                (sku) =>
                  sku.color === product.skus[0].color && sku.countInStock > 0
              )) ||
            sideProduct.skus.find((sku) => sku)
          );
        })
      );
    }
  }, [
    loadingSideProducts,
    errorSideProducts,
    sideProducts,
    product,
    skuData,
    sideSkuData,
  ]);

  // FIND IF CHOOSEN VARIANT IS NOT AVAILABLE IN ONE OF THE SIDE PRODUCTS
  const [variantNotFound, setVariantNotFound] = useState(false);
  useEffect(() => {
    if (choosenSetOfSideProducts && choosenSetOfSideProducts.length > 0) {
      const targetExist = removeDuplicatesFromArray(
        choosenSetOfSideProducts.map((item) => item.target)
      ).length;
      const typeExist = removeDuplicatesFromArray(
        choosenSetOfSideProducts.map((item) => item.type)
      ).length;
      const sizeExist = removeDuplicatesFromArray(
        choosenSetOfSideProducts.map((item) => item.size)
      ).length;
      const colorExist = removeDuplicatesFromArray(
        choosenSetOfSideProducts.map((item) => item.color)
      ).length;

      if (targetExist > 1 || typeExist > 1 || sizeExist > 1 || colorExist > 1) {
        setVariantNotFound(true);
      } else {
        setVariantNotFound(false);
      }
    }
  }, [choosenSetOfSideProducts]);

  // ADD TO CART
  const [cartSkuItemsLength, setCartSkuItemsLength] = useState("");
  const [addFreeProduct, setAddFreeProduct] = useState(""); // State to hold free product details to be dispatched in useEffect
  const [runOnlyOnce, setRunOnlyOnce] = useState(false); // This is the switch to avoid multiple dispatches in useEffect
  const [loadingCart, setLoadingCart] = useState("");

  function addToCartHandler(
    productId,
    sku,
    freeProductId,
    freeProductSkus,
    buyOneGetOneFree,
    index,
    discounted,
    free,
    timeLimitedDiscountAmount
  ) {
    //IF VARIANTS ARE NOT FULLY SELECTED SET ALERT
    if (
      variants.fullVariantsArray.length !== choosenVariants.length &&
      !variants.singleSku
    ) {
      return setVariantAlert({
        index: index,
        message: "Özellik seçmelisiniz!",
      });
    }

    setLoadingCart(index);

    setCartSkuItemsLength(cartSkuItems.length);
    setRunOnlyOnce(true);

    setAddedInCart((prev) => [productId, ...prev]);
    setAddedSkuInCart((prev) => [sku, ...prev]);
    setReadyToAddNew(false);

    free = true;
    discounted = true;

    if (
      freeProductId &&
      freeProductId === productId &&
      cartSkuItems.length > 0 &&
      buyOneGetOneFree
    ) {
      // First add the main product in cart
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          discounted,
          "",
          timeLimitedDiscountAmount
        )
      );

      // Than save free product details and add to cart in useEffect after main product has been added in cart
      setAddFreeProduct({
        isThereApendingOrder,
        freeProductId,
        sku,
        qty: 1,
        buttonLocation: "sideProducts",
        discounted: false,
        free: true,
      });
    } else if (
      freeProductId &&
      freeProductId !== productId &&
      cartSkuItems.length > 0 &&
      buyOneGetOneFree
    ) {
      // COMPARE FREE PRODUCT SKU WITH FREE PRODUCT PROVIDER SKU TO MATCH COLOR SETS
      const filtered = freeProductSkus.find((pSku) => {
        return (
          pSku.substring(pSku.length - 3, pSku.length) ===
          sku.substring(sku.length - 3, sku.length)
        );
      });

      // First add the main product in cart
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          discounted,
          "",
          timeLimitedDiscountAmount
        )
      );

      // Than save free product details and add to cart in useEffect after main product has been added in cart
      setAddFreeProduct({
        isThereApendingOrder,
        freeProductId,
        sku: filtered,
        qty: 1,
        buttonLocation: "sideProducts",
        discounted: false,
        free: true,
      });
    } else if (
      freeProductId &&
      freeProductId === productId &&
      cartSkuItems.length === 0 &&
      buyOneGetOneFree
    ) {
      // First add the main product in cart
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          !discounted,
          !free,
          timeLimitedDiscountAmount
        )
      );

      // Than save free product details and add to cart in useEffect after main product has been added in cart
      setAddFreeProduct({
        isThereApendingOrder,
        freeProductId,
        sku,
        qty: 1,
        buttonLocation: "sideProducts",
        discounted: false,
        free: true,
      });
    } else if (
      freeProductId &&
      freeProductId !== productId &&
      cartSkuItems.length === 0 &&
      buyOneGetOneFree
    ) {
      // COMPARE FREE PRODUCT SKU WITH FREE PRODUCT PROVIDER SKU TO MATCH COLOR SETS
      const filtered = freeProductSkus.find((pSku) => {
        return (
          pSku.substring(pSku.length - 3, pSku.length) ===
          sku.substring(sku.length - 3, sku.length)
        );
      });

      // First add the main product in cart
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          "",
          "",
          timeLimitedDiscountAmount
        )
      );

      // Than save free product details and add to cart in useEffect after main product has been added in cart
      setAddFreeProduct({
        isThereApendingOrder,
        freeProductId,
        sku: filtered,
        qty: 1,
        buttonLocation: "sideProducts",
        discounted: false,
        free: true,
      });
    } else if (cartSkuItems.length === 1 && cartSkuItems[0].sku === sku) {
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          "",
          "",
          timeLimitedDiscountAmount
        )
      );
    } else if (cartSkuItems.length > 0) {
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          discounted,
          "",
          timeLimitedDiscountAmount
        )
      );
    } else {
      dispatch(
        actionToAddSkuItemInCart(
          isThereApendingOrder,
          productId,
          sku,
          1,
          "sideProducts",
          "",
          "",
          timeLimitedDiscountAmount
        )
      );
    }
  }

  // DETECT IF ITEM ADDED IN THE CART
  const [addedInCart, setAddedInCart] = useState(
    JSON.parse(localStorage.getItem("addedInCart"))
      ? JSON.parse(localStorage.getItem("addedInCart"))
      : []
  );
  useEffect(() => {
    if (addedInCart) {
      localStorage.setItem("addedInCart", JSON.stringify(addedInCart));
    }
  }, [dispatch, addedInCart]);

  // If there is a main product with free product promotion than this useEffect run
  useEffect(() => {
    if (
      // This is the object that holds free product info
      addFreeProduct &&
      // This line makes sure that free product dispatched after main product to make sure that 0 priced item is after the main product in array
      cartSkuItems.length > cartSkuItemsLength &&
      // This is a switch to make sure useEffect is run only once each time
      runOnlyOnce
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          addFreeProduct.isThereApendingOrder,
          addFreeProduct.freeProductId,
          addFreeProduct.sku,
          addFreeProduct.qty,
          addFreeProduct.buttonLocation,
          addFreeProduct.discounted,
          addFreeProduct.free
        )
      );

      // Switching back to false to stop multiple dispatches
      setRunOnlyOnce(false);
      setAddFreeProduct("");
    }
  }, [dispatch, addFreeProduct, cartSkuItems, cartSkuItemsLength, runOnlyOnce]);

  // DETECT IF SKU ADDED IN THE CART
  const [addedSkuInCart, setAddedSkuInCart] = useState(
    JSON.parse(localStorage.getItem("addedSkuInCart"))
      ? JSON.parse(localStorage.getItem("addedSkuInCart"))
      : []
  );
  useEffect(() => {
    if (addedSkuInCart) {
      localStorage.setItem("addedSkuInCart", JSON.stringify(addedSkuInCart));
    }
  }, [dispatch, addedSkuInCart]);
  // DISPLAY SET PRICE
  const [addedSkus, setAddedSkus] = useState([]);
  useEffect(() => {
    const skusInCart = cartSkuItems.filter((sku) =>
      addedSkuInCart.toString().includes(sku.sku)
    );
    setAddedSkus(skusInCart);
  }, [addedSkuInCart, cartSkuItems]);

  return (
    <SideProductModalContent
      width={width}
      product={product}
      alertRef={alertRef}
      addedInCartRef={addedInCartRef}
      cartSkuItems={cartSkuItems}
      variants={variants}
      setChoosenVariants={setChoosenVariants}
      choosenVariants={choosenVariants}
      setVariantAlert={setVariantAlert}
      variantAlert={variantAlert}
      loadingSku={loadingSku}
      setNoSkuAlert={setNoSkuAlert}
      variantNotFound={variantNotFound}
      addedSkus={addedSkus}
      setScrollHeight={setScrollHeight}
      history={history}
      choosenSetOfSideProducts={choosenSetOfSideProducts}
      loadingCart={loadingCart}
      cartSkuItemsLength={cartSkuItemsLength}
      addedInCart={addedInCart}
      isThereApendingOrder={isThereApendingOrder}
      qty={qty}
      readyToAddNew={readyToAddNew}
      addToCartHandler={addToCartHandler}
      createdFingerPrint={createdFingerPrint}
    />
  );
}
